import { render, staticRenderFns } from "./BuildGrid.vue?vue&type=template&id=72f6d0fa&scoped=true"
import script from "./BuildGrid.vue?vue&type=script&lang=js"
export * from "./BuildGrid.vue?vue&type=script&lang=js"
import style0 from "./BuildGrid.vue?vue&type=style&index=0&id=72f6d0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6d0fa",
  null
  
)

export default component.exports